wbApp.directive('wbShoppingCart', [
    function () {

        return {
            restrict: 'A',
            priority: 1,
            scope: {
                ngModel: '='
            },
            template:
            '<button type="button" class="btn btn-lg btn-warning shopping-cart-btn"' +
            '       data-animation="am-flip-x"' +
            '       data-auto-close="0"' +
            '       data-template-url="rents/shopping-cart-popover.html"' +
            '       data-container="body"' +
            '       data-placement="bottom-right"' +
            '       title="{{\'TXT_SHOPPING_CART\' | translate}}"' +
            '       bs-popover>' +
            '   <i class="fa fa-2x fa-shopping-cart" aria-hidden="true"></i>' +            
            '   <div class="badge">{{ngModel.itemsCount}}</div>' +
            '</button>',
            controller: ['$scope', '$modal', 'securitySvc', 'shoppingCartSvc', 'studentSvc', 'rentCategorySvc', 'notificationSvc', 'urlUtils', 'messageBoxSvc',
                function ($scope, $modal, securitySvc, shoppingCartSvc, studentSvc, rentCategorySvc, notificationSvc, urlUtils, messageBoxSvc) {

                    var selectStudentDlg = $modal({
                        templateUrl: 'rents/select-student-dialog.html',
                        show: false,
                        backdrop: 'static',
                        scope: $scope
                    });


                    var notRegisteredUserDlg = $modal({
                        templateUrl: 'rents/not-registered-user-dialog.html',
                        show: false,
                        backdrop: 'static',
                        scope: $scope
                    });

                    $scope.removeItem = function (rent, $index) {
                        shoppingCartSvc.removeRentItemFromShoppingCart($scope.ngModel, rent, $index);
                        $scope.$emit('onRemoveItemFromShoppingCart', $scope.ngModel);
                    }


                    function handleSaveError(problemDetails, model) {
                        if (!problemDetails.type) {
                            return; // We do not knwo what kind of error object it is.
                        }

                        if (problemDetails.type.endsWith("order-aggregate-exception")) {
                            model.errors = {
                                errors: _.map(problemDetails.aggregateProblemDetails, function (apd) {
                                    return { message: apd.title }
                                })
                            };
                            //hasErrors
                            _.forEach(problemDetails.aggregateProblemDetails, function (pd) {
                                if (pd.type.endsWith("rent-business-rule-violation")) {
                                    var rent = _.find(model.rents, function (r) {
                                        var result = pd.placeId == r.placeId &&
                                            moment(pd.fromUtc).isSame(r.startDate) &&
                                            moment(pd.toUtc).isSame(r.endDate);

                                        return result;
                                    });
                                    if (!!rent) {
                                        rent.hasErrors = true;
                                    }
                                    if (!!pd.rentItemIds) {
                                        _.forEach(pd.rentItemIds, function (id) {
                                            var rentedItems = _.filter(rent.rentedItems, { id: id });
                                            if (!!rentedItems) {
                                                _.forEach(rentedItems, function (r) {
                                                    r.hasErrors = true;
                                                });
                                                
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    }
                   
                    // model - shoppingCart
                    $scope.onRentBtnClick = function (model, hideFn) {
                        
                        rentCategorySvc.getAll().$promise.then(function (allRentCategories) {
                            var usedCategories = _.filter(allRentCategories, function (c) {
                                return !!_.find(model.rents || [], function(rent) {
                                    return !!_.find(rent.rentedItems || [], { rentCategoryId: c.id });
                                });
                            });

                            // Full validation is on server, just collect all needed info, server desides
                            // if the setting makes any sense at all
                            var accessPermissions = _.reduce(usedCategories, function (result, value, key) {
                                switch (value.accessPermissions) {
                                    case 0: // LoggedInUsersOnlyStudentRequired
                                        result.studentRequired = true;
                                        break;
                                    case 1: // AllowAnonymousNoStudent
                                        result.allowAnonymous = true;
                                        break;
                                    case 2: // AllowAnonymousStudentRequired
                                        result.allowAnonymous = true;
                                        result.studentRequired = true;
                                        break;
                                    case 3: // LoggedInUsersOnlyNoStudent
                                        break;
                                }
                                return result;
                            }, {
                                studentRequired: false,
                                allowAnonymous:false
                            });
                            
                            if (!securitySvc.isAuthenticated() && !accessPermissions.allowAnonymous) {
                                notificationSvc.advertiseLogin(urlUtils.getParamsStringWithoutReturnUrl(urlUtils.getQueryParams()));
                                return;
                            }

                            if (securitySvc.isAuthenticated() && !!accessPermissions.studentRequired) {
                                studentSvc.getCurrentAsync().$promise.then(function (students) {

                                    if (!students || !students.length) {

                                        messageBoxSvc.showMessageDlg({
                                            title: 'TXT_PLACEHOLDER_SELECT_STUDENT',
                                            message: 'TXT_ERROR_NO_STUDENTS_2',
                                            buttons: [{
                                                text: 'TXT_BTN_CANCEL'
                                            }, {
                                                text: 'TXT_BTN_ADD_STUDENT',
                                                callback: function () {
                                                    window.location = "/MyAccount?tabName=students&returnOnSave=true&returnUrl=" + encodeURIComponent(location.pathname + location.search);
                                                    return;
                                                }
                                            }]
                                        });
                                    } else {
                                        // Show select student form

                                        selectStudentDlg.$promise.then(function () {
                                            selectStudentDlg.$scope.students = students;
                                            selectStudentDlg.$scope.isStudentSelected = false;
                                            selectStudentDlg.$scope.onSelectStudent = function (student) {
                                                _.forEach(students, function (s) {
                                                    if (s != student) {
                                                        s.selected = null;
                                                    } else {
                                                        s.selected = true;
                                                    }
                                                });
                                                selectStudentDlg.$scope.isStudentSelected = true;
                                            };
                                            selectStudentDlg.$scope.onRentAfterStudentSelection = function (d, hideFn2) {

                                                var loggedInUser = securitySvc.loggedInUser();
                                                model.userId = loggedInUser.userID;
                                                model.studentId = _.find(students, { selected: true }).id;
                                                model.isNotRegisteredUser = false;
                                                model.notRegisteredUserInfo = null;

                                                hideFn2();

                                                shoppingCartSvc.rentShoppingCart(model).$promise.then(function () {
                                                    shoppingCartSvc.emptyShoppingCart($scope.ngModel);                                                    
                                                    hideFn();
                                                    $scope.$emit('onRentShoppingCartSaved', $scope.ngModel);
                                                }, function (error) {
                                                    handleSaveError(error.data, model);
                                                });
                                            };
                                            selectStudentDlg.show();
                                        });
                                    }
                                });
                            }
                            else {

                                if (securitySvc.isAuthenticated() && !accessPermissions.studentRequired) {
                                    var loggedInUser = securitySvc.loggedInUser();
                                    model.userId = loggedInUser.userID;
                                    model.studentId = null;
                                    model.isNotRegisteredUser = false;
                                    model.notRegisteredUserInfo = null;

                                    shoppingCartSvc.rentShoppingCart(model).$promise.then(function () {
                                        shoppingCartSvc.emptyShoppingCart($scope.ngModel);
                                        hideFn();
                                        $scope.$emit('onRentShoppingCartSaved', $scope.ngModel);
                                    }, function (error) {
                                        handleSaveError(error.data, model);
                                    });
                                }
                                else {
                                    if (!!accessPermissions.allowAnonymous) {
                                        notRegisteredUserDlg.$promise.then(function () {
                                            notRegisteredUserDlg.$scope.registration = { notRegisteredUserInfo: null };
                                            notRegisteredUserDlg.$scope.isStudentRequired = accessPermissions.studentRequired;
                                            notRegisteredUserDlg.$scope.onAnonymousBtnClick = function () {
                                                notRegisteredUserDlg.$scope.registration.notRegisteredUserInfo = {
                                                    surname: null,
                                                    email: null,
                                                    phone: null,
                                                    students: accessPermissions.studentRequired ? [] : null
                                                };
                                            };
                                            notRegisteredUserDlg.$scope.onRentAfterNotRegisteredUserClick = function (d, hideFn2) {
                                                model.userId = null;
                                                model.studentId = null;
                                                model.isNotRegisteredUser = true;
                                                model.notRegisteredUserInfo = notRegisteredUserDlg.$scope.registration.notRegisteredUserInfo;

                                                shoppingCartSvc.rentShoppingCart(model).$promise.then(function () {
                                                    shoppingCartSvc.emptyShoppingCart($scope.ngModel);
                                                    hideFn2();
                                                    hideFn();
                                                    $scope.$emit('onRentShoppingCartSaved', $scope.ngModel);
                                                }, function (error) {
                                                    handleSaveError(error.data, model);
                                                });
                                            }
                                            notRegisteredUserDlg.show();
                                        });
                                    }
                                }
                            }
                        });
                    }
                }]
        }
    }]);